<template>
  <div class="layout-img">
    <b-row>
      <template v-for="(item, index) in dataList">
        <b-col :key="index" sm="4" cols="6" class="block">
          <router-link
            :to="`/forum/project/detail?id=${item.id}&categoryId=${item.categoryId}`"
          >
            <div class="img-wrap img-hovor">
              <img width="100%" height="100%" :src="item.titleImg" />
            </div>
            <div>
              <p v-if="item.title" class="title" style="">
                {{ item.title }}
              </p>
              <p v-if="item.cycle" class="cycle">
                {{ item.cycle }}
              </p>
            </div>
          </router-link>
        </b-col>
      </template>
    </b-row>
    <div class="summary" v-if="summary">
      <div class="typeName">{{ typeName }}</div>
      <div class="sum">{{ summary }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      type: "",
      year: "",
      cycle: "",
      dataList: [],
      index: "",
      summary: "",
      typeName: "",
    };
  },
  watch: {
    $route: {
      handler(to) {
        this.type = to.query.type;
        this.year = to.query.year;
        this.cycle = to.query.cycle;
        this.index = to.query.index;
        this.getActivityList();
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.getActivityList();
  },
  methods: {
    getActivityList(type) {
      this.dataList = []; //清空
      this.$forumApi
        .activityList({
          categoryId: this.type,
          year: this.year,
          cycle: this.cycle,
        })
        .then((res) => {
          if (res.code == 200) {
            this.dataList = res.data;
            this.getSummary();
          }
        });
    },
    getSummary() {
      this.typeName = "";
      this.summary = "";
      this.$forumApi.activityCategory().then((res) => {
        res.data.map((item, index) => {
          if (this.index == index) {
            this.typeName = item.name;
            this.summary = item.summary;
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.layout-img ::v-deep {
  min-height: 30rem;
  margin-top: 1rem;

  .img-wrap {
    width: 100%;
    height: 15rem;
    margin: 1rem auto;
    border-radius: 10px;
    img:hover {
      transform: scale(1.05, 1.05);
      transition: transform 0.8s cubic-bezier(0.215, 0.61, 0.355, 1),
        opacity 0.36s cubic-bezier(0.215, 0.61, 0.355, 1);
    }
  }

  a {
    text-decoration: none;
    cursor: pointer;
    color: #4a4a4a;
  }

  p {
    margin-top: 0.5rem;
    color: #4a4a4a;
    margin-left: 0.5rem;
    font-size: 15px;
    font-family: Arial, "Microsoft YaHei";
  }

  .title {
    height: 3.3rem;
    margin-bottom: 2rem;
    overflow: hidden;
    font-size: 17px;
  }
  .typeName {
    display: flex;
    justify-content: center;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #4a4a4a;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .sum {
    line-height: 34px;
    color: #666666;
    font-size: 16px;
  }
  .summary {
    border-top: 1px solid #ebebeb;
    border-bottom: 1px solid #ebebeb;
    margin: 205px 0px 30px 0px;
    padding: 50px 0px;
  }
  .row {
    margin-right: 0px;
    margin-left: 0px;
  }
  .cycle {
    color: #999999;
    font-size: 13px;
    font-weight: 400;
  }
}

@media (max-width: 768px) {
  .layout-img ::v-deep {
    .img-wrap {
      height: 54%;
      border-radius: 6px;
      overflow: hidden;
      width: 90%;
    }
    .col-6 {
      max-width: unset;
      padding: unset;
    }
    .block {
      margin-bottom: 30px;
    }
    .cycle {
      position: absolute;
      transform: scale(0.88);
    }
    .title {
      height: 4.5rem;
      margin: 0rem;
      overflow: hidden;
      font-size: 12px;
      margin-left: 15px;
      width: 10rem;
    }
    .typeName {
      font-size: 19px;
      margin-bottom: 14px;
    }
    .sum {
      line-height: 28px;
    }
    .summary {
      padding: 38px 0px;
    }
    p {
      width: 16rem;
      margin-top: 0.5rem;
      color: #4a4a4a;
    }

    .col-md-4,
    .col-7 {
      padding-right: 0.1rem;
      padding-left: 0.1rem;
    }
    .row {
      flex-wrap: wrap;
    }
  }
}
</style>